import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import Passwordless from 'supertokens-web-js/recipe/passwordless';

// For now, we only do CSR, treating the app as an SPA.
export const ssr = false;

export const load = async () => {
  SuperTokens.init({
    appInfo: {
      apiDomain: __API_DOMAIN__,
      apiBasePath: '/auth',
      appName: 'docket-iis-core',
    },
    recipeList: [Passwordless.init(), Session.init()],
  });

  return {
    // In case child layouts need to know
    supertokensInitialized: true,
  };
};
